/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], function(){
	/**
     *we could pass options for initialization
     *@constructor
     */
	let MigrateUtils = () => {
		return {
			isEmpty: value => {
				return (
					value === undefined ||
                    value === null ||
                    (typeof value === 'object' && Object.keys(value).length === 0) ||
                    (Array.isArray(value) && value.length === 0) ||
                    (typeof value === 'string' && value.trim().length === 0)
				);
			},

			specMissing: (spec) => {
				return !spec;
			},

			isInlineModule: (sources) => {
				const filteredSources = sources.find(source =>
					source.hasOwnProperty('module')
				);
				return !!filteredSources;
			}
		};
	};
	return new MigrateUtils();
});